import './VersionNumber.css';

export const VersionNumber = () => {
    return (
        <div className="VersionNumber-container">
            <div className="VersionNumber">v6.0</div>
        </div>
    );
};